import { createDefaultFormatters, createStandardConfig } from './utils'

/**
 * New Zealand Address Configuration
 */
export const NZ_CONFIG = createStandardConfig({
  countryCode: 'NZ',
  countryName: 'New Zealand',
  requiresStreetNumber: true,
  formatters: createDefaultFormatters({ address2Style: 'forwardSlash' }),
  fieldOverrides: {
    address2: {
      labelKey: 'address-config.unit-flat'
    },
    city: {
      labelKey: 'address-config.city-town',
      errorKey: 'address-config.city-town-required'
    },
    stateOrProvince: {
      required: false,
      preferLongName: true,
      labelKey: 'address-config.region'
    },
    postalCode: {
      required: false,
      labelKey: 'address-config.postcode',
      errorKey: 'address-config.postcode-required'
    }
  }
})
